export const FONT_LIST = 
[
    { value : "arial,sans-serif", text : "Arial" },
    { value : "verdana,sans-serif", text : "Verdana" },
    { value : "'trebuchet ms',sans-serif", text : "Tahoma" },
    { value : "'Times New Roman',serif", text : "Trebuchet" },
    { value : "georgia,serif", text : "Times New Roman" },
    { value : "garamond,serif", text : "Georgia" },
    { value : "'courier new',monospace", text : "Garamond" },
    { value : "'Brush Script MT',cursive", text : "Courier New" },
    { value : "", text : "Brush Script MT" }
];